import styled from "@emotion/styled";

export const Root = styled.div<{ inline?: boolean }>(props => ({
    display: props.inline ? "inline-flex" : "flex",
}));
